// INFO: routeFeature and routesUrl are used only as type derivation sources.
// eslint-disable-next-line @typescript-eslint/no-unused-vars
const routeFeature = ['chat', 'others', 'getStarted', 'iframeTest', 'error'] as const;
// eslint-disable-next-line @typescript-eslint/no-unused-vars
const routesUrl = ['/:section/:subsection', '/:section','/get-started', '/fleet-assistant-integration', '/error'] as const;


type RouteFeature = (typeof routeFeature)[number];
type RoutesUrl = (typeof routesUrl)[number];

type Getters<T extends string, K> = {
  [k in T]: K;
};

type RoutesData = Getters<RouteFeature, RoutesUrl>;

const routes: RoutesData = {
  chat: '/:section/:subsection',
  others: '/:section',
  getStarted: '/get-started',
  iframeTest: '/fleet-assistant-integration',
  error: "/error",
} as const;

export type AppRoute = RoutesData[keyof RoutesData];

export enum EAppRoutes {
  CHAT = '/chat',
  ABOUT = '/about',
  FEEDBACK = '/feedback',
  ONBOARDING = '/onboardingMode',
};

export default routes;
